import React from 'react'
import {
  FEE_PROJECT_TYPES,
  FeeProjectType,
  FeesByProductType,
  ITenant,
  LoanCalculations,
  ProductFee,
} from '@oneethos/shared'
import ProductFeeEditor from '../product-fee-editor'

const PROJECT_TYPE_LABELS: Record<FeeProjectType, string> = {
  residential: 'Residential',
  commercial: 'Commercial',
  'non-profit': 'Non-profit',
}

type FeesConfigProps = {
  config: Partial<ITenant>
  setConfig: (config: Partial<ITenant>) => void
}

export const FeesConfig = ({ config, setConfig }: FeesConfigProps) => {
  const feesByProductType: FeesByProductType = config.feesByProductType || {}

  const updateFees = (projectType: FeeProjectType, fees: ProductFee[]) => {
    setConfig({
      ...config,
      feesByProductType: {
        ...feesByProductType,
        [projectType]: fees,
      },
    })
  }

  return (
    <div className="tenant-config mt-3">
      <p className="text-muted">
        Configurable fees are in addition to Doc Stamps and Recordation Tax, and will 
        appear before those fees on the loan documents.
        Doc Stamps and Recordation Tax are calculated based on applicable
        laws in the state where the project is installed.
        Percentage fees are based on the loan amount before fees.
      </p>
      <p className="text-muted">
        Fees apply to every product of the same type. Clearing every fee and
        saving means that Product Type has
        no configured fees.         
      </p>
      {FEE_PROJECT_TYPES.map(projectType => (
        <section key={projectType} className="card fees-product-type mb-4">
          <div className="card-header">
            <h5 className="mb-0">{PROJECT_TYPE_LABELS[projectType]}</h5>
          </div>
          <div className="card-body">
            <ProductFeeEditor
              fees={feesByProductType[projectType] ?? LoanCalculations.defaultProductFees(projectType)}
              productType={projectType}
              onChange={fees => updateFees(projectType, fees)}
            />
          </div>
        </section>
      ))}
    </div>
  )
}
